export { default as TabNew } from './TabNew';
export { default as TabsViewNew } from './TabsViewNew';
